<template>
<div class="news-wrap" ref="newsContainer">
  <div class="news-content">
    <Header></Header>
    <div class="news-info">
      <NewsTemplate :listData="newsList"></NewsTemplate>
    </div>
    <Footer class="app-footer"></Footer>
  </div>
</div>
</template>

<script>
import NewsTemplate from '@/components/NewsTemplate/NewsTemplate';
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';
import BScroll from 'better-scroll';
export default {
  name: 'NewsAndInformation',
  components: {
    NewsTemplate,
    Header,
    Footer
  },
  data() {
    return {
      newsList: [],
      pageSize: 8,
      page: 1
    }
  },
  created() {
    this.getNewsList();
    setTimeout(() => {
      this.$nextTick(() => {
        this.initScroll()
      })
    }, 500)
  },
  mounted() {

  },
  methods: {
    async getNewsList(page=1) {
      const result = await this.$http.newsAndInformation.getNewsList({
        classify: 1,
        page:page
      });
      if (result.code === 200) {
        this.newsList.push(...result.data);
      } else {
        
        return
      }
    },
   initScroll() {
      this.scroll = new BScroll(this.$refs.newsContainer, {
        scrollY: true,
        click: true,
        probeType: 3,
        pullUpLoad: {
          threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
          stop: 20
        },
      })
      this.scroll.on('pullingUp', async (params) => {
        
        const {
          page,
          pageSize
        } = this
        this.page = page + 1;
        await this.getNewsList(this.page)
        
        
        this.$nextTick(() => {
          this.scroll.refresh()
          this.scroll.finishPullUp()
        })
      })
    },
  }
}
</script>

<style lang="less">
.news-wrap {
  height: 100vh;

  .news-info {
    padding: 0 20px;
  }
}
</style>
